module.exports = __webpack_public_path__ + "static/Product-card-04.8c6db77e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Product-card-04.png
// module id = ./src/images/Product-card-04.png
// module chunks = 4016850265702045000